var React = require('react');

function Twitter (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M14.9 2.9A3.59 3.59 0 0 0 16.412.901a6.697 6.697 0 0 1-2.187.877A3.36 3.36 0 0 0 11.712.636C9.811.636 8.27 2.255 8.27 4.251c0 .283.028.559.088.823C5.496 4.923 2.96 3.485 1.26 1.297a3.743 3.743 0 0 0-.466 1.818c0 1.253.608 2.36 1.532 3.01a3.332 3.332 0 0 1-1.56-.453v.045c0 1.752 1.186 3.213 2.763 3.544a3.22 3.22 0 0 1-.908.127c-.222 0-.439-.022-.648-.064.438 1.435 1.71 2.482 3.217 2.51A6.705 6.705 0 0 1 .092 13.33a9.421 9.421 0 0 0 5.278 1.624c6.335 0 9.797-5.508 9.797-10.285 0-.157-.002-.313-.008-.467a7.177 7.177 0 0 0 1.718-1.872 6.624 6.624 0 0 1-1.978.569z"}));
}

Twitter.defaultProps = {"width":"1em","height":"1em","viewBox":"0 0 17 15"};

module.exports = Twitter;

Twitter.default = Twitter;
